<script setup lang="ts">
import {
  AlarmCheck,
  AlarmClock,
  AlarmMinus,
  AlarmPlus,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignJustify,
  ArrowDown,
  ArrowDownAZ,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  ArrowUpDown,
  ArrowUpNarrowWide,
  ArrowsUpFromLine,
  ArrowUpToLine,
  Ban,
  Bell,
  Bold,
  BookCopy,
  Cable,
  Calendar,
  CalendarArrowDown,
  CalendarArrowUp,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarX,
  ChartNoAxesGantt,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  CirclePlus,
  Clock,
  ClockArrowDown,
  CloudLightning,
  Code,
  Columns3,
  Copy,
  CornerDownRight,
  CornerUpLeft,
  Crosshair,
  Delete,
  Diamond,
  DollarSign,
  Edit3,
  Ellipsis,
  Equal,
  Eraser,
  Eye,
  EyeOff,
  ExternalLink,
  File,
  FileDiff,
  FileText,
  FileSymlink,
  Filter,
  FolderRoot,
  FolderTree,
  Gauge,
  Globe,
  GripVertical,
  Group,
  Home,
  History,
  Info,
  Italic,
  Key,
  KeyRound,
  Laptop,
  Layers2,
  Layout,
  LayoutGrid,
  LifeBuoy,
  Library,
  Link,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  Locate,
  Lock,
  LockOpen,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Megaphone,
  MessageSquareQuote,
  MessageSquareText,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MinusSquare,
  MoreVertical,
  MoreHorizontal,
  MessageCircleMore,
  MessageCirclePlus,
  PanelTop,
  MousePointer,
  Move,
  MoveHorizontal,
  Navigation,
  Octagon,
  Paintbrush,
  Paperclip,
  Pencil,
  Pilcrow,
  Play,
  Plus,
  PlusSquare,
  Presentation,
  Redo,
  RefreshCw,
  Rocket,
  RotateCw,
  Rows2,
  Rows4,
  Save,
  Scaling,
  ScissorsLineDashed,
  ScrollText,
  Search,
  SearchX,
  Settings,
  Sparkles,
  ChartPie,
  Slash,
  SquareCheck,
  Star,
  StarHalf,
  Table,
  Tag,
  Target,
  Terminal,
  ToggleRight,
  Trash2,
  TrendingDown,
  Triangle,
  Type,
  Undo,
  Undo2,
  Unlink,
  User,
  UserCheck,
  UserCog,
  Users,
  Wrench,
  XCircle,
  XIcon,
  Image,
  Video,
  Zap,
} from 'lucide-vue-next';
import BeeActivityAdd from './icons/custom/activity-add.svg';
import BeeActivityConnect from './icons/custom/activity-connect.svg';
import BeeActivityOutline from './icons/custom/activity-outline.svg';
import BeeActivity from './icons/custom/activity.svg';
import ChatGPTIcon from './icons/custom/ChatGPT_logo.svg';
import BeeCompressTool from './icons/custom/compress-tool.svg';
import BeeConnectionsAll from './icons/custom/connections-all.svg';
import BeeConnectionsDirect from './icons/custom/connections-direct.svg';
import BeeConnectionsFull from './icons/custom/connections-full.svg';
import BeeConnectionsMilestoneAll from './icons/custom/connections-milestone-all.svg';
import BeeConnectionsMilestoneNone from './icons/custom/connections-milestone-none.svg';
import BeeConnectionsMilestoneRequired from './icons/custom/connections-milestone-required.svg';
import BeeConnectionsNone from './icons/custom/connections-none.svg';
import BeeFillModeDefault from './icons/custom/fill-mode-default.svg';
import BeeFillModeStatus from './icons/custom/fill-mode-status.svg';
import BeeGrid from './icons/custom/grid.svg';
import BeeLocateToday from './icons/custom/locate-today.svg';
import BeeLogoBeeboard from './icons/custom/logo-beeboard.svg';
import BeeMilestoneAdd from './icons/custom/milestone-add.svg';
import BeeMilestoneOutline from './icons/custom/milestone-outline.svg';
import BeeMilestoneOverlay from './icons/custom/milestone-overlay.svg';
import BeeMilestone from './icons/custom/milestone.svg';
import BeeMoveToolHorizontal from './icons/custom/move-tool-horizontal.svg';
import BeeMoveToolVertical from './icons/custom/move-tool-vertical.svg';
import BeePhaseAdd from './icons/custom/phase-add.svg';
import BeePhaseOutline from './icons/custom/phase-outline.svg';
import BeePhase from './icons/custom/phase.svg';
import BeeProjects from './icons/custom/projects.svg';
import BeeRoadMap from './icons/custom/roadmap.svg';
import BeeLabelTitle from './icons/custom/small-t.svg';
import BeeSpaceToolExpand from './icons/custom/space-tool-expand.svg';
import BeeSpaceTool from './icons/custom/space-tool.svg';
import BeeTeams from './icons/custom/teams.svg';
import BeeTemplates from './icons/custom/templates.svg';
import BeeWorkstreamAdd from './icons/custom/workstream-add.svg';
import BeeWorkstreamOutline from './icons/custom/workstream-outline.svg';
import BeeWorkstream from './icons/custom/workstream.svg';

export type IconName = keyof typeof icons;

const icons = {
  AlarmCheck,
  AlarmClock,
  AlarmMinus,
  AlarmPlus,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignJustify,
  ArrowDown,
  ArrowDownAZ,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  ArrowUpDown,
  ArrowUpNarrowWide,
  ArrowsUpFromLine,
  ArrowUpToLine,
  Ban,
  Bell,
  BeeActivity,
  BeeActivityAdd,
  BeeActivityConnect,
  BeeActivityOutline,
  BeeCompressTool,
  BeeConnectionsAll,
  BeeConnectionsDirect,
  BeeConnectionsFull,
  BeeConnectionsNone,
  BeeConnectionsMilestoneAll,
  BeeConnectionsMilestoneNone,
  BeeConnectionsMilestoneRequired,
  BeeFillModeDefault,
  BeeFillModeStatus,
  BeeGrid,
  BeeLabelTitle,
  BeeLocateToday,
  BeeLogoBeeboard,
  BeeMilestone,
  BeeMilestoneAdd,
  BeeMilestoneOutline,
  BeeMilestoneOverlay,
  BeeMoveToolHorizontal,
  BeeMoveToolVertical,
  BeePhase,
  BeePhaseAdd,
  BeePhaseOutline,
  BeeProjects,
  BeeRoadMap,
  BeeSpaceTool,
  BeeSpaceToolExpand,
  BeeTeams,
  BeeTemplates,
  BeeWorkstream,
  BeeWorkstreamAdd,
  BeeWorkstreamOutline,
  Bold,
  BookCopy,
  Cable,
  Calendar,
  CalendarArrowDown,
  CalendarArrowUp,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarX,
  ChartNoAxesGantt,
  ChatGPTIcon,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  CirclePlus,
  Clock,
  ClockArrowDown,
  CloudLightning,
  Code,
  Columns3,
  Copy,
  CornerDownRight,
  CornerUpLeft,
  Crosshair,
  Delete,
  Diamond,
  DollarSign,
  Edit3,
  Ellipsis,
  Equal,
  Eraser,
  Eye,
  EyeOff,
  ExternalLink,
  File,
  FileSymlink,
  FileDiff,
  FileText,
  Filter,
  FolderRoot,
  FolderTree,
  Globe,
  GripVertical,
  Group,
  Gauge,
  Home,
  History,
  Info,
  Italic,
  Key,
  KeyRound,
  Laptop,
  Layers2,
  Layout,
  LayoutGrid,
  LifeBuoy,
  Library,
  Link,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  Locate,
  Lock,
  LockOpen,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Megaphone,
  MessageCircleMore,
  MessageCirclePlus,
  MessageSquareQuote,
  MessageSquareText,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MinusSquare,
  MoreVertical,
  MoreHorizontal,
  MousePointer,
  Move,
  MoveHorizontal,
  Navigation,
  Octagon,
  Paintbrush,
  PanelTop,
  Paperclip,
  Pencil,
  Pilcrow,
  Play,
  Plus,
  PlusSquare,
  Presentation,
  Redo,
  RefreshCw,
  Rocket,
  RotateCw,
  Rows2,
  Rows4,
  Save,
  Scaling,
  ScissorsLineDashed,
  ScrollText,
  Search,
  SearchX,
  Settings,
  Sparkles,
  ChartPie,
  Slash,
  SquareCheck,
  Star,
  StarHalf,
  Table,
  Tag,
  Target,
  Terminal,
  ToggleRight,
  Trash2,
  TrendingDown,
  Triangle,
  Type,
  Undo,
  Undo2,
  Unlink,
  User,
  UserCheck,
  UserCog,
  Users,
  Wrench,
  XCircle,
  XIcon,
  Image,
  Video,
  Zap,
} as const;

const props = withDefaults(
  defineProps<{
    name: keyof typeof icons;
    size?: number;
    strokeWidth?: number;
    noStroke?: boolean;
    absoluteStrokeWidth?: boolean;
    stroke?: string;
  }>(),
  {
    size: 24,
    strokeWidth: 2,
    noStroke: false,
    absoluteStrokeWidth: true,
    stroke: 'currentColor',
  },
);

const icon = computed(() => icons[props.name]);
</script>

<template>
  <component
    :is="icon"
    :stroke="stroke"
    :size="size"
    :stroke-width="noStroke ? 0 : strokeWidth"
    :absolute-stroke-width="absoluteStrokeWidth"
  />
</template>
